import { Expose, Type } from "class-transformer";

import { BaseModel } from "src/shared/models/base.model";
import { InsuredContact } from "src/shared/models/insured-contact.model";

export class User extends BaseModel {
    @Expose() analyticsId = "";
    @Expose() firstSurname = "";
    @Expose() lastSurname = "";
    @Expose() names = "";
    @Expose() userIdentity = "";
    @Expose() gwCode?: number;
    @Expose() axCode?: number;
    @Expose() nsCode?: number;
    @Expose() viCode?: number;
    // @Expose() fullName = "";
    // @Expose() shortName = "";
    @Expose()
    @Type(() => InsuredContact)
    insuredContact: InsuredContact = new InsuredContact();

    get displayName() {
        return this.names?.includes(" ")
            ? this.names?.split(" ")[0]
            : this.names;
    }

    get fullName() {
        return `${this.names} ${this.firstSurname} ${this.lastSurname}`;
    }

    get shortName() {
        return `${this.names} ${this.firstSurname}`;
    }
}
